export const ADD_APPOINTMENT_NOTE = 'add_appointment_note';
export const CREATE_PATIENT_APPOINTMENT= 'create_patient_appointment';